<template>
  <NuxtLayout :name="layoutName" :navbar-color="layoutNavbarColor">
    <div v-if="story" class="categories">
      <div class="container">
        <BlogBreadcrumbs />
      </div>

      <section class="categories__section">
        <div class="container">
          <h2 class="categories__heading">Explore all topics</h2>
          <BlogCategories :categories="categoriesData" />
        </div>
      </section>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
const storyblokApi = useStoryblokApi()

const queryParams = {
  starts_with: 'blog/categories',
  filter_query: {
    component: {
      in: 'blog-category',
    },
  },
  per_page: 100,
}
const { data: categoriesData } = await useAsyncData(
  'categories',
  async () => await storyblokApi.get('cdn/stories', queryParams),
  { transform: (data) => data.data.stories },
)
const { story } = await useFetchStory('blog/categories')

const { getBreadcrumbsJsonLd } = useBreadcrumbs()

useCustomHead(story, {
  jsonLd: getBreadcrumbsJsonLd(),
})

defineI18nRoute({
  locales: ['en'],
})

const { layoutName, layoutNavbarColor } = useStoryLayout<any>(story)
</script>

<style lang="scss" scoped>
.categories {
  &__section {
    padding: 80px 0;
    background-color: var(--paper-100);

    @media (min-width: $breakpoint-md) {
      padding: 128px 0;
    }
  }

  &__heading {
    margin-bottom: 40px;
  }
}
</style>
